export default "__VITE_ASSET__OBjsCj2b__"